import { fetchInfoUserProfile } from './actions';

export const userProfileActions = { fetchInfoUserProfile };
